// import { FiSliders } from "react-icons/fi";
import { FaSliders } from "react-icons/fa6";

const FilterButton = ({ onClick }) => (
  <button onClick={onClick} className="p-2 border rounded">
    <FaSliders size={18}/>
  </button>
);

export default FilterButton;
